// extracted by mini-css-extract-plugin
export var body = "pxyMNZKI1qb8VqKIjZ4h";
export var fontBold = "zfbcM5nVXabsn_WQs9VP";
export var fontMedium = "fiNBsh8E0yZxMlgNMvtE";
export var fontRegular = "u17QTBj1NE5kbwtPCZK4";
export var large = "ZaRFEyg4NubwWlJq32yg";
export var micro = "Pjla3XJvFitWT4IrnRcf";
export var mini = "mA5c18j1ekZitwVU4JXX";
export var root = "a1xFNKVc6VqTOmHwK8cG";
export var small = "uKh9ifnrB6oeuGiYLHDB";